import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import {
  Overlay,
  Container,
  Header,
  Title,
  Close,
  Message,
  Line,
  Confirm,
} from './InventoryImportStatusDialog.styles';

interface IInventoryImportStatusDialog {
  open: boolean;
  onClose: () => void;
}

export const InventoryImportStatusDialog = ({
  open,
  onClose,
}: IInventoryImportStatusDialog) => {
  const portalDiv = document.getElementById('portal');

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header>
              <Title>Success</Title>
              <Close onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </Close>
            </Header>

            <Message>
              File submitted succesfully. You will receive an email notification
              when your data is ready.
            </Message>

            <Line>
              <Confirm type="button" onClick={onClose}>
                Ok
              </Confirm>
            </Line>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
